export default class {
  getFileExt(name) {
    return name
      .split(/[#?]/)[0]
      .split(".")
      .pop()
      .trim();
  }

  getFileType(file) {
    let fileType = null;
    if (file.type) fileType = file.type;
    else if (file.raw && file.raw.type) fileType = file.raw.type;
    if (fileType) {
      if (fileType.match("image.*")) return "image";

      if (fileType.match("video.*")) return "video";

      if (fileType.match("audio.*")) return "audio";
       
      if (fileType.match("pdf.*")) return "pdf";
      return "other";
     
    } else if (file.url) {
      const type = this.getFileExt(file.url);
      switch (type) {
        case "mp4":
        case "avi":
        case "mpeg":
        case "quicktime":
          return "video";
        case "jpg":
        case "jpeg":
        case "png":
          return "image";
        case "pdf":
          return "pdf";
        default:
          break;
      }
    } else return undefined;
  }
}
